import { Backdrop, Box, Divider, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const FiltersRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  width: '100%'
}));

const SectionActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(2),
  alignItems: 'flex-end'
}));

const PageTitle = styled(Typography)(() => ({
  fontWeight: 'bold'
}));

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  color: '#fff',
  zIndex: theme.zIndex.drawer + 1
}));

const ContentBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px'
});

const HeaderBox = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(5)
}));

const FiltersRowContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  width: '100%'
}));

const UnauthorizedMessage = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column'
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(2),
  width: '100%'
}));

const UnauthorizedMessageText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  marginLeft: theme.spacing(2)
}));

const ExamFilterBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '170px'
}));

const ExamFilterLabel = styled(Typography)(() => ({
  marginBottom: '6px'
}));

export {
  FiltersRow,
  SectionActions,
  PageTitle,
  ExamFilterLabel,
  StyledBackdrop,
  ContentBox,
  HeaderBox,
  FiltersRowContainer,
  UnauthorizedMessage,
  StyledDivider,
  UnauthorizedMessageText,
  ExamFilterBox
};
